import { render, staticRenderFns } from "./PanelLastCampaignTableRow.vue?vue&type=template&id=17f88d28&scoped=true&"
import script from "./PanelLastCampaignTableRow.vue?vue&type=script&lang=ts&"
export * from "./PanelLastCampaignTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f88d28",
  null
  
)

export default component.exports